import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ExperienceAccordion from "../../containers/experienceAccordion/ExperienceAccordion.js";
// import experience from '../../shared/experience_data.json';
import "./Experience.css";
import { Fade } from "react-reveal";

const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many evolving startups as Software Engineer, Web Developer and Full Stack Developer. I have also worked with some well established foundation. I love attending events and I am also involved with opensource communities as a Mentor or the Collaborator.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer",
          company: "Plexusmd",
          company_url: "https://www.plexusmd.com/md/",
          logo_path: "plexusmd.png",
          duration: "July 2021 - Present",
          location: "Work From Home",
          description: `• Improved, developed and updated Medflix App components UI using React-Native according to the design.
						  • Developed Gremlin API’s for various sections in the app like adminPanel section, events, discussions, clubs etc.`,
          color: "	#FF0000",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Engineer Intern",
          company: "Plexusmd",
          company_url: "https://www.plexusmd.com/md/",
          logo_path: "plexusmd.png",
          duration: "November 2020 - July 2021",
          location: "Work From Home",
          description: `• Reduced website load by 20% by implementing an AMP webpage for plexusmd post, jobs and medcast-video page.
						  • Developed Node.js API for various pages like event-pages, jobs, profile-section, connection-section etc.
						  • Improved search efficiency inside the app and website by developing API’s for Apache-SOLR using Node.js, MySQL
						  and Loopback.
						  • Increased the website load performance by 30% using AMP, Node.js and Express.js.`,
          color: "	#FF0000",
        },
        {
          title: "Full Stack Developer Intern",
          company: "Prescribe",
          company_url: "https://www.heyprescribe.com/",
          logo_path: "logo-prescribe.jpg",
          duration: "August 2020 - September 2020",
          location: "Work From Home",
          description: `• Developed a dashboard for doctor’s schedule and details using React.js, Material-UI and ant-design etc. .
						 • My work was to manage and update both backend and frontend of the website.`,
          color: "	#22418d",
        },
        {
          title: "Web Developer Intern",
          company: "GirlScript Jamshedpur",
          company_url: "https://girlscript-jamshedpur.github.io/",
          logo_path: "logo-jamshed.jpg",
          duration: "May 2020 - November 2020",
          location: "Work From Home",
          description:
            "I got the opportunity to be part of the GirlScript Jamshedpur Team. I'm responsible for \r\n1.)  Making and maintaining the Website throughout this role \r\n2.) Handling technical accounts on Github and other coding platforms .",
          color: "#000000",
        },

        {
          title: "Web Developer and UI/UX Intern",
          company: "InfyU Labs",
          company_url: "https://www.infyulabs.com/",
          logo_path: "infyu-logo.png",
          duration: "May 2020 - August 2020",
          location: "Work From Home",
          description: `• Collaborated with the team to design, structure and implement new website from start to finish and updated the
						existing website.
						• Participated in weekly meetings with the team.
						• Developed a user-friendly architecture.`,
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Assistant Action Developer",
          company: "Google Developers",
          company_url: "https://developers.google.com/",
          logo_path: "googleAssistant.svg",
          duration: "September 2019 - PRESENT",
          location: " ",
          description:
            "Developed a Google Assistant Action Flashdart FAQ that is available on 2 Billion devices world wide. To awake the action quiz...Just say 'Okay Google, Talk to Flashdart FAQ'",
          color: "#4285F4",
        },
        {
          title: "Amazon Alexa Skill Developer",
          company: "Amazon Alexa Developers",
          company_url: "https://developer.amazon.com/alexa/console/ask",
          logo_path: "amazonAlexa.png",
          duration: "Nov 2019 - PRESENT",
          location: " ",
          description:
            "I Build Skill on Amazon Alexa. Alexa is Amazon's voice service and the brain behind millions of devices including Amazon Echo. Alexa provides capabilities, or skills, that enable customers to create a more personalized experience. I Have Made Six Facts Skills On Amazon Alexa. (1) Web Facts-'Alexa, open web facts' (2)Programming Facts-'Alexa, open programming facts' (3) Best Programming Language-'Alexa, open best programming language' (4) Classic Car Facts-'Alexa, open classic car facts' (5) Movie Facts-'Alexa, open movies facts' (6) Best Developer Skills-'Alexa, open best developer skills.'",
          color: "#D83B01",
        },
        {
          title: "React Mentor",
          company: "The Uplift Project(GirlScript Foundation)",
          company_url: "https://www.girlscript.tech/home",
          logo_path: "uplift.png",
          duration: "Jun 2020 - August 2020",
          location: "Work From Home",
          description:
            "Being a mentor my responsibility is (1).  Guiding the team properly and assigning tasks and deadlines to them (2). Participated in weekly meetings with the participants (3). Mentors have to keep check of the progress of the participants.",
          color: "#0C9D58",
        },
        {
          title: "Open Source Contributor",
          company: "GirlScript Summer Of Code 2020",
          company_url: "https://www.gssoc.tech/index.html#",
          logo_path: "gssoc.jpg",
          duration: "Mar 2020 - May 2020",
          location: "Work From Home",
          description:
            "Girlscript Summer Of Code is a 3-month long open source project under Girlscript India. In this Summer Of Code,I worked on the “AWESOME REACT MODULES” in which my 8 Pull Requests got merged.",
          color: "#000000",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Girlscript Foundation, Opengenus, Awesome React Modules, cropAI, GirlScript Jamshedpur, fnplus, GirlScript Chennai Website, Digital-Ocean etc. These contributions include bug fixes, feature requests and formulating proper documentation for projects.",
          color: "#181717",
        },
      ],
    },
  ],
};

class Experience extends Component {
  render() {
    return (
      <div className="experience-main">
        <Header />
        <div className="basic-experience">
          <Fade bottom duration={1000} distance="40px">
            <div className="experience-heading-div">
              <div className="experience-heading-img-div">
                <img
                  src={require(`../../assests/images/${experience["header_image_path"]}`)}
                  alt=""
                />
              </div>
              <div className="experience-heading-text-div">
                <h1 className="experience-heading-text">{experience.title}</h1>
                <h3 className="experience-heading-sub-text">
                  {experience["subtitle"]}
                </h3>
                <p className="experience-header-detail-text subTitle">
                  {experience["description"]}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        <ExperienceAccordion sections={experience["sections"]} />
        <Footer />
      </div>
    );
  }
}

export default Experience;
